import { DrugTestResultEnum } from "@repo/models";
import { DateTimePicker, DropDownList, FiltersV2, Loading } from "@repo/ui";
import { useCallback, useState } from "react";

import type { DrugTestsFilter } from "../../api/drugTestsApi";

import { emptySegmentFilters, SegmentFilters } from "../../components/segmentFilters";
import { DrugTestsGrid } from "./grid";

const initialFilters: DrugTestsFilter = {
	currentPage: 1,
	itemsPerPage: 25,
	startDate: null,
	endDate: null,
	brands: emptySegmentFilters.brandIds,
	channels: emptySegmentFilters.channelIds,
	marketers: emptySegmentFilters.marketerIds,
	states: emptySegmentFilters.stateIds,
	branches: emptySegmentFilters.branchIds,
	result: undefined,
};

const resultOptions = [
	{ label: "[ALL]", value: "ALL" },
	{ label: "Negative", value: DrugTestResultEnum.Negative.toString() },
	{ label: "Positive", value: DrugTestResultEnum.Positive.toString() },
	{ label: "Inconclusive", value: DrugTestResultEnum.Inconclusive.toString() },
	{ label: "Refusal", value: DrugTestResultEnum.Refusal.toString() },
	{ label: "Adulterated", value: DrugTestResultEnum.Adulterated.toString() },
	{ label: "Diluted", value: DrugTestResultEnum.Diluted.toString() },
];

export function DrugTestsPage() {
	const [filters, setFilters] = useState<DrugTestsFilter>(initialFilters);
	const [executedFilters, setExecutedFilters] = useState<DrugTestsFilter>(initialFilters);

	const filterChanged = useCallback(
		(value: any, name: string) => {
			setFilters((prev) => ({ ...prev, [name]: value }));
		},
		[setFilters],
	);

	const segmentFiltersChanged = useCallback(
		(s) =>
			setFilters((prev) => ({
				...prev,
				brands: s.brandIds,
				channels: s.channelIds,
				marketers: s.marketerIds,
				states: s.stateIds,
				branches: s.branchIds,
			})),
		[setFilters],
	);

	return (
		<div className="w-full">
			<FiltersV2
				onApply={() =>
					setExecutedFilters((currentFilters) => ({
						...filters,
						currentPage: 1,
						itemsPerPage: currentFilters.itemsPerPage,
					}))
				}
			>
				<DateTimePicker
					id="startDate"
					label="Conducted After:"
					dateOnly
					value={filters.startDate}
					changeHandler={filterChanged}
				/>
				<DateTimePicker
					id="endDate"
					label="Conducted Before:"
					dateOnly
					value={filters.endDate}
					changeHandler={filterChanged}
				/>
				<SegmentFilters onChange={segmentFiltersChanged} />
				<DropDownList
					id="result"
					label="Result:"
					values={resultOptions}
					value={filters.result ?? "ALL"}
					changeHandler={(v) => filterChanged(v === "ALL" ? undefined : v, "result")}
					fullLength
				/>
			</FiltersV2>
			<DrugTestsGrid filters={executedFilters} setFilters={setExecutedFilters} />
		</div>
	);
}
